import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      
      <main className="flex-1 py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Syarat dan Ketentuan</h1>
          <p className="text-slate-500 mb-8">Terakhir diperbarui: 27 Juli 2026</p>
          
          <div className="prose prose-slate max-w-none">
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Penerimaan Ketentuan</h2>
              <p className="text-slate-600">
                Dengan mengakses dan menggunakan layanan Bimbel My Tentor di mytentor.id, Anda menyatakan 
                telah membaca, memahami, dan setuju untuk terikat dengan Syarat dan Ketentuan ini. 
                Jika Anda tidak setuju, mohon untuk tidak menggunakan layanan kami.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Definisi</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li><strong>"Platform"</strong> merujuk pada website mytentor.id dan semua layanan terkait</li>
                <li><strong>"Pengguna"</strong> merujuk pada siswa/peserta yang mendaftar dan menggunakan layanan</li>
                <li><strong>"Layanan"</strong> mencakup try out online, materi pembelajaran, video, dan ebook</li>
                <li><strong>"Admin"</strong> merujuk pada pengelola Bimbel My Tentor</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Pendaftaran Akun</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2">
                <li>Pengguna wajib memberikan informasi yang akurat dan lengkap saat mendaftar</li>
                <li>Setiap pengguna hanya boleh memiliki satu akun</li>
                <li>Pengguna bertanggung jawab menjaga kerahasiaan password akun</li>
                <li>Pengguna wajib segera melaporkan jika ada penggunaan tidak sah atas akunnya</li>
                <li>Pengguna minimal berusia 13 tahun atau mendapat izin orang tua/wali</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Penggunaan Layanan</h2>
              <p className="text-slate-600 mb-4">Pengguna dilarang untuk:</p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>Menyebarkan soal, jawaban, atau materi tanpa izin tertulis</li>
                <li>Menggunakan bot, script, atau alat otomatis untuk mengerjakan try out</li>
                <li>Berbagi akun dengan orang lain</li>
                <li>Mengakses sistem secara tidak sah atau mencoba meretas platform</li>
                <li>Melakukan kecurangan dalam try out (menyontek, bekerja sama, dll)</li>
                <li>Mengunggah konten yang melanggar hukum, SARA, atau tidak pantas</li>
                <li>Mengganggu atau merusak layanan bagi pengguna lain</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Layanan Berbayar dan Pembayaran</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2">
                <li>Harga paket try out tercantum jelas di platform dan dapat berubah sewaktu-waktu</li>
                <li>Pembayaran dapat dilakukan melalui transfer bank sesuai petunjuk yang diberikan</li>
                <li>Akses ke layanan berbayar diberikan setelah pembayaran dikonfirmasi admin</li>
                <li>Bukti pembayaran harus diunggah melalui platform untuk verifikasi</li>
                <li>Verifikasi pembayaran membutuhkan waktu maksimal 1x24 jam kerja</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Kebijakan Pengembalian Dana</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2">
                <li>Pengembalian dana dapat diajukan dalam 7 hari setelah pembayaran JIKA layanan belum digunakan sama sekali</li>
                <li>Pengajuan pengembalian dana dilakukan dengan menghubungi admin via WhatsApp</li>
                <li>Tidak ada pengembalian dana jika pengguna sudah mengakses try out atau materi berbayar</li>
                <li>Promo, diskon, atau paket bundling tidak dapat dikembalikan dananya</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Hak Kekayaan Intelektual</h2>
              <p className="text-slate-600 mb-4">
                Seluruh konten di platform termasuk namun tidak terbatas pada:
              </p>
              <ul className="list-disc list-inside text-slate-600 mb-4 space-y-1">
                <li>Soal-soal try out dan pembahasan</li>
                <li>Materi pembelajaran dan video</li>
                <li>Ebook dan modul</li>
                <li>Logo, desain, dan tampilan website</li>
              </ul>
              <p className="text-slate-600">
                Adalah milik Bimbel My Tentor dan dilindungi hak cipta. Dilarang menyalin, 
                mendistribusikan, atau menggunakan untuk kepentingan komersial tanpa izin tertulis.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Event Try Out</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2">
                <li>Peserta event harus terdaftar dan memiliki nomor peserta yang valid</li>
                <li>Try out hanya dapat dikerjakan dalam waktu yang ditentukan oleh admin</li>
                <li>Hasil try out bersifat final dan tidak dapat diganggu gugat</li>
                <li>Ranking disusun berdasarkan skor tertinggi dan waktu pengerjaan tercepat</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Batasan Tanggung Jawab</h2>
              <ul className="list-disc list-inside text-slate-600 space-y-2">
                <li>Layanan disediakan "sebagaimana adanya" tanpa jaminan tertentu</li>
                <li>Kami tidak bertanggung jawab atas kerugian tidak langsung dari penggunaan layanan</li>
                <li>Kami tidak menjamin hasil kelulusan ujian tertentu dari penggunaan layanan</li>
                <li>Gangguan teknis atau maintenance dapat terjadi sewaktu-waktu</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Penangguhan dan Penghentian</h2>
              <p className="text-slate-600 mb-4">
                Kami berhak menangguhkan atau menghentikan akun pengguna yang:
              </p>
              <ul className="list-disc list-inside text-slate-600 space-y-1">
                <li>Melanggar Syarat dan Ketentuan ini</li>
                <li>Melakukan kecurangan atau penipuan</li>
                <li>Merugikan pengguna lain atau platform</li>
                <li>Tidak membayar tagihan yang jatuh tempo</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">11. Perubahan Ketentuan</h2>
              <p className="text-slate-600">
                Kami dapat mengubah Syarat dan Ketentuan ini kapan saja. Perubahan akan 
                diberitahukan melalui email atau notifikasi di platform. Penggunaan layanan 
                setelah perubahan berarti Anda menyetujui ketentuan yang diperbarui.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">12. Hukum yang Berlaku</h2>
              <p className="text-slate-600">
                Syarat dan Ketentuan ini tunduk pada hukum Republik Indonesia. Setiap perselisihan 
                akan diselesaikan secara musyawarah, dan jika tidak tercapai kesepakatan, akan 
                diselesaikan melalui Pengadilan Negeri Medan.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-slate-900 mb-4">13. Kontak</h2>
              <p className="text-slate-600 mb-4">
                Pertanyaan mengenai Syarat dan Ketentuan ini dapat disampaikan ke:
              </p>
              <div className="bg-slate-50 rounded-lg p-4 text-slate-600">
                <p><strong>Bimbel My Tentor</strong></p>
                <p>Alamat: Jl. Gaperta No. 218 A Medan Helvetia</p>
                <p>Email: mytentor2017@gmail.com</p>
                <p>WhatsApp: +62 812 6201 7001</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
